import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={8} lg={7} className="m-auto text-center">
            <h3 className="h3_head">
              Tech Stacks For <span>Ionic App Development</span>
            </h3>
            <p>
              Explore our unique and cutting-edge tech stacks that are designed
              primarily for Ionic App Development.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/frontend/AngularJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AngularJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/frontend/HTML.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>HTML</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/frontend/Ionic.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Ionic</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/frontend/TypeScript.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>TypeScript</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/backend/ExpressJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>ExpressJs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/backend/Firebase.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Firebase</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/backend/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/backend/Node_js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Development Tools">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/devlopment/Jest.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jest</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/devlopment/Visual_Studio_Code.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Visual Studio Code</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Analytics & Monitoring">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/analytics/Google_Analytics.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Analytics</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/analytics/sentry.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Sentry</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="CICD">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/cicd/GitHub_Actions.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitHub Actions</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/cicd/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Deployment">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/deployment/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/deployment/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/deployment/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/deployment/Heroku.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Heroku</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Version Control">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/version/Git.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Git</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ionic-app/version/Github.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Github</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
